import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

type LinkProps = {
  canNavigate?: boolean;
};

export const NameLink = styled(Text12)<LinkProps>`
  font-weight: bold;
  ${(props) => (props.canNavigate ? 'cursor: pointer' : '')};

  &:hover {
    ${(props) => (props.canNavigate ? 'text-decoration: underline;' : '')};
  }
`;

NameLink.defaultProps = {
  themeColor: ThemeColorType.gray,
};
